<template>
  <v-dialog v-model="dialog" persistent scrollable width="600">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Nộp giấy tờ gốc
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <div class="mb-3 text-body-1 black--text">1. Thông tin hồ sơ</div>
        <div class="mb-1">
          Mã hồ sơ: <strong>{{ $get(item, 'code') }}</strong>
        </div>
        <div class="mb-1">
          Tên thí sinh: <strong>{{ $get(item, 'cv.name') }}</strong>
        </div>
        <div class="mb-1">
          Điểm Ngôn ngữ: <strong>{{ $get(item, 'cv.ltvExamResult.examLanguage') }}</strong>
        </div>
        <div class="mb-1">
          Điểm Tư duy: <strong>{{ $get(item, 'cv.ltvExamResult.examMathMark') }}</strong>
        </div>
        <div class="mb-1">
          Tổng điểm: <strong>{{ $get(item, 'cv.ltvExamResult.examTotal') }}</strong>
        </div>
        <div class="mb-1">
          Đợt đăng ký: <strong>{{ $get(item, 'retryType', 0) > 0 ? '2' : '1' }}</strong>
        </div>
        <div class="mb-1">
          Đã xếp lớp: <strong>{{ $get(item, 'assignedClassTitle', '-Chưa được xếp lớp-') }}</strong>
        </div>
        <v-divider class="my-3" />
        <div class="mb-3 text-body-1 black--text">2. Thông tin xác nhận</div>
        <v-form ref="form">
          <v-row>
            <v-col cols="4" class="pb-0">Học bạ Tiểu học (bản gốc)</v-col>
            <v-col cols="8" class="pb-0">
              <v-radio-group v-model="studyDoc" class="pa-0 mt-0" row>
                <v-radio :value="true" label="Đã nộp" />
                <v-radio :value="false" label="Chưa nộp" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pb-0">Giấy khai sinh (bản sao)</v-col>
            <v-col cols="8" class="pb-0">
              <v-radio-group v-model="birthDoc" class="pa-0 mt-0" row>
                <v-radio :value="true" label="Đã nộp" />
                <v-radio :value="false" label="Chưa nộp" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pb-0">Phiếu “Thông tin tài khoản đăng ký tuyển sinh” (do Bộ GD&ĐT cấp)</v-col>
            <v-col cols="8" class="pb-0">
              <v-radio-group v-model="accountDoc" class="pa-0 mt-0" row>
                <v-radio :value="true" label="Đã nộp" />
                <v-radio :value="false" label="Chưa nộp" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="pb-0">Giấy tờ chứng minh diện ưu tiên (nếu có).</v-col>
            <v-col cols="8" class="pb-0">
              <v-radio-group v-model="giftedDoc" class="pa-0 mt-0" row>
                <v-radio :value="true" label="Đã nộp" />
                <v-radio :value="false" label="Chưa nộp" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
import {get} from 'lodash'
export default {
  data: () => ({
    dialog: false,
    item: null,
    loading: false,
    //
    studyDoc: false,
    birthDoc: false,
    accountDoc: false,
    giftedDoc: false,
  }),
  methods: {
    ...mapActions({
      updateDocumentStates: 'assignClass/updateDocumentStates',
    }),
    async openDialog(item = {}) {
      this.item = item
      this.studyDoc = get(item, 'documentStates.studyDoc', false)
      this.birthDoc = get(item, 'documentStates.birthDoc', false)
      this.accountDoc = get(item, 'documentStates.accountDoc', false)
      this.giftedDoc = get(item, 'documentStates.giftedDoc', false)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSubmit() {
      this.loading = true
      try {
        await this.updateDocumentStates({
          id: this.item.id,
          documentStates: {
            studyDoc: this.studyDoc,
            birthDoc: this.birthDoc,
            accountDoc: this.accountDoc,
            giftedDoc: this.giftedDoc,
          },
        })
        this.$emit('onRefresh')
        this.$alert.success('Xác nhận nhập học thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>